import React from "react";
import { Box, styled, Typography } from "@mui/material";
import iconCartEmpty from "../../../images/icon/ic-cart-empty-grey.svg";
import { useTranslation } from "react-i18next";

const Link = styled("a")(() => ({
  fontFamily: "Patua One",
  fontSize: "18px",
  fontWeight: "normal",
  lineHeight: "21.94px",
  textAlign: "center",
  textDecoration: "underline",
}));

const DrawerBodyEmpty = () => {
  const urlBaseV4 = process.env.REACT_APP_V4_BASE_URL;
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: "1rem",
        padding: "0 2rem",
        overflowY: "auto",
        marginBottom: 16
      }}
    >
      <img src={iconCartEmpty} alt="icono carrito vacío" style={{ marginTop: "2rem" }} />

      <Typography fontFamily="Roboto" fontSize="16px" fontWeight="500" lineHeight="24px" textAlign="center" sx={{ my: "1.5rem" }}>
        {t("header.drawer.text.empty")}
      </Typography>

      <Link href={urlBaseV4 + "/hosting"}>{t("header.drawer.url.hosting")}</Link>

      <Link href={urlBaseV4 + "/encuentra-tu-dominio"}>{t("header.drawer.url.domains")}</Link>
    </Box>
  );
};

export default DrawerBodyEmpty;
